export const arrayUniqueByKey = <T>(array: T[], key: keyof T): T[] => [
  ...new Map(array.map((item) => [item[key], item])).values(),
];
